import { render, staticRenderFns } from "./PopupWithBtn.vue?vue&type=template&id=78970fb9&scoped=true&"
import script from "./PopupWithBtn.vue?vue&type=script&lang=js&"
export * from "./PopupWithBtn.vue?vue&type=script&lang=js&"
import style0 from "./PopupWithBtn.vue?vue&type=style&index=0&id=78970fb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78970fb9",
  null
  
)

export default component.exports